import styled from 'styled-components';

const Space = styled.div`
  height: 16px;
`;

export {Space};